import { Box } from '@nimbus-ds/components';
import { Layout } from 'commons/components';
import { useStoreStatus } from 'domains/Auth/hooks';
import {
  NoFiscalDataAlert,
  AccountData,
  ApplyDiscount,
  RecurrentPaymentsStatus,
  FreePlanCard,
  PaymentsTabs,
  DevelopmentCard,
} from '../';

function PlansAndSubscriptionsV2(): JSX.Element {
  const { storeStatus } = useStoreStatus();

  const isStoreDevelopment = storeStatus === 'development';

  return (
    <>
      {!isStoreDevelopment && <NoFiscalDataAlert />}
      <Layout
        mainContent
        left={
          <Box display="flex" flexDirection="column" gap="4">
            {isStoreDevelopment ? (
              <DevelopmentCard />
            ) : (
              <>
                <FreePlanCard />
                <PaymentsTabs />
                <RecurrentPaymentsStatus />
              </>
            )}
          </Box>
        }
        right={
          <Box display="flex" flexDirection="column" gap="4">
            <AccountData />
            {!isStoreDevelopment && <ApplyDiscount />}
          </Box>
        }
        orderMobile="reverse"
      />
    </>
  );
}

export default PlansAndSubscriptionsV2;
